import '@upside/flux-ui/lib/styles/global.css';
import '@upside/react-components/lib/styles/global.css';

// page layout overides for global header
import './global-header.css';
import initialiseShell from './shell';

initialiseShell().catch(() => {
  // eslint-disable-next-line no-console
  console.error('Error initialising the shell');
});
